import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ddmhdunv: FaireBrandEntity = {
  token: "b_ddmhdunv",
  type: "brand",
  name: "Kalastyle Soap Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/ede9672d0b9eeec24a6b2d69ba7f04bf3017305fa4cab7bfb868e788cab26d4d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5be7b19dfc8afe8cf45404507868fd28da6d981700c7d22bf505e052bca6580a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ede9672d0b9eeec24a6b2d69ba7f04bf3017305fa4cab7bfb868e788cab26d4d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5be7b19dfc8afe8cf45404507868fd28da6d981700c7d22bf505e052bca6580a.jpeg",
  location: "Cranston, RI, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 244,
  isTopShop: true,
  isInsider: true,
  description:
    "KalaStyle Soap Co. is a second-generation, family-owned and operated business located in the beautiful Ocean State, better known locally as Little Rhody! For almost 40 years, our small but mighty team has been importing the absolute best in personal care products, focusing on old-world, heritage brands from Europe to the States. Today, husband-and-wife duo Alice and Cleveland are committed to clean beauty practices using high-quality, natural, and organic Nordic ingredients in products we make in-house and use at home. With only a handful of midsize soap makers left in the country (fewer than 10), we are proud to be one of them! \n\nWith backgrounds in Printmaking, Art History, Photography, and Production, our shared passion is creating tried-and-true, eye-catching, high-performing brands. Keeping up with trends is great, but we’re more interested in making products that stand the test of time. Nothing makes us happier than hearing our customers say, “This is the only soap I’ll use!”\n\nWe would not be here without the loyalty and hard work of so many incredible stores across the country, extremely fun, talented, and dedicated Reps, and our wildly awesome KalaStyle Team, who is, without a doubt, our chosen family. Their dedication and hard work are the pillars of our success, ensuring that every product we deliver is of the highest quality and meets our commitment to clean beauty.\n\nSuds up, and cheers to another 40 years!\n\nAlice & Cleveland",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:11.593Z",
    importedBy: "entity-db-cli",
  },
};
